// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `group-members {
  display: block;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  background-color: var(--motes-white);
  border-radius: var(--border-radius);
  color: var(--motes-dark);
}
group-members .member-container {
  min-height: 6em;
  max-height: 13em;
  overflow: hidden;
  scrollbar-color: var(--motes-gray) var(--motes-white);
}
@media only screen and (max-height: 600px) {
  group-members .member-container {
    overflow-y: auto;
    max-height: 10em;
    touch-action: auto;
  }
}
group-members .member {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
}
group-members .member span {
  display: flex;
  align-items: center;
  gap: 0.5em;
}
group-members .member:nth-child(odd) {
  background-color: var(--motes-light-gray);
}
group-members .member:first-child {
  background-color: var(--motes-highlight-color);
}
group-members .member-info {
  width: 100%;
  margin-right: 1.5em;
  display: flex;
  justify-content: space-between;
}
group-members group-member-state-indicator {
  font-size: 1.5em;
}
group-members .member-menu-container {
  display: inline-block;
  width: 1em;
  margin-left: -1em;
  position: relative;
  cursor: pointer;
  align-items: center;
}
group-members .member-menu-container svg-icon {
  font-size: 1.5em;
}
group-members .member-menu-container:hover {
  cursor: pointer;
}
group-members .member-menu {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0%, -25%);
  padding: 0.5em;
  white-space: nowrap;
  background-color: var(--motes-red);
  color: var(--motes-white);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  opacity: 1;
  transition: 0.2s ease-in;
}
group-members .hide {
  visibility: hidden;
  transform: translate(50%, -25%);
  opacity: 0;
}
group-members ::-webkit-scrollbar {
  z-index: 1;
  background: var(--motes-white);
  position: relative;
}
group-members ::-webkit-scrollbar-thumb {
  background-color: var(--motes-gray);
  border: 3px solid transparent;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/group-members/group-members.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;EACA,mCAAA;EACA,wBAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qDAAA;AACR;AAEI;EACI;IACI,gBAAA;IACA,gBAAA;IACA,kBAAA;EAAV;AACF;AAGI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AADR;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,UAAA;AADZ;AAKI;EACI,yCAAA;AAHR;AAMI;EACI,8CAAA;AAJR;AAOI;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AALR;AAQI;EACI,gBAAA;AANR;AASI;EACI,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAPR;AASQ;EACI,gBAAA;AAPZ;AAWI;EACI,eAAA;AATR;AAYI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;EACA,yBAAA;EACA,mCAAA;EACA,6BAAA;EACA,UAAA;EACA,wBAAA;AAVR;AAaI;EACI,kBAAA;EACA,+BAAA;EACA,UAAA;AAXR;AAcI;EACI,UAAA;EACA,8BAAA;EACA,kBAAA;AAZR;AAeI;EACI,mCAAA;EACA,6BAAA;AAbR","sourcesContent":["group-members {\n    display: block;\n    box-sizing: border-box;\n    overflow: hidden;\n    width: 100%;\n    background-color: var(--motes-white);\n    border-radius: var(--border-radius);\n    color: var(--motes-dark);\n\n    .member-container {\n        min-height: 6em;\n        max-height: 13em;\n        overflow: hidden;\n        scrollbar-color: var(--motes-gray) var(--motes-white);\n    }\n\n    @media only screen and (max-height: 600px) {\n        .member-container {\n            overflow-y: auto;\n            max-height: 10em;\n            touch-action: auto; // Allow refresh pull (despite the drawbacks) and scroll on very small devices\n        }\n    }\n\n    .member {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0.5em;\n\n        span {\n            display: flex;\n            align-items: center;\n            gap: 0.5em;\n        }\n    }\n\n    .member:nth-child(odd) {\n        background-color: var(--motes-light-gray);\n    }\n\n    .member:first-child {\n        background-color: var(--motes-highlight-color);\n    }\n\n    .member-info {\n        width: 100%;\n        margin-right: 1.5em;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    group-member-state-indicator {\n        font-size: 1.5em;\n    }\n\n    .member-menu-container {\n        display: inline-block;\n        width: 1em;\n        margin-left: -1em;\n        position: relative;\n        cursor: pointer;\n        align-items: center;\n\n        svg-icon {\n            font-size: 1.5em;\n        }\n    }\n\n    .member-menu-container:hover {\n        cursor: pointer;\n    }\n\n    .member-menu {\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translate(0%, -25%);\n        padding: 0.5em;\n        white-space: nowrap;\n        background-color: var(--motes-red);\n        color: var(--motes-white);\n        border-radius: var(--border-radius);\n        box-shadow: var(--box-shadow);\n        opacity: 1;\n        transition: 0.2s ease-in;\n    }\n\n    .hide {\n        visibility: hidden;\n        transform: translate(50%, -25%);\n        opacity: 0;\n    }\n\n    ::-webkit-scrollbar {\n        z-index: 1;\n        background: var(--motes-white);\n        position: relative;\n    }\n\n    ::-webkit-scrollbar-thumb {\n        background-color: var(--motes-gray);\n        border: 3px solid transparent;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
